module.exports = __webpack_public_path__ + "img/analyse-svgrepo-com.a24d2b85.svg";